import { createRoot } from 'react-dom/client';

import browser from '@openclassrooms/utils/browser';

import { ClassicFooterContainer } from 'Modules/layout';
import AppProviders from 'Modules/webapp/components/AppProviders';

import Footer from 'Modules/footer/components/Footer';

export { Footer };

function footerInit() {
  const footerWrapper = browser.document.getElementById('footerWrapper');

  if (!footerWrapper) {
    return;
  }

  const root = createRoot(footerWrapper);
  root.render(
    <AppProviders productionPrefix="footer">
      <ClassicFooterContainer>
        <Footer />
      </ClassicFooterContainer>
    </AppProviders>
  );
}

export default footerInit;
